import { render, staticRenderFns } from "./addActionTypeModal.vue?vue&type=template&id=16b5672f&"
import script from "./addActionTypeModal.vue?vue&type=script&lang=js&"
export * from "./addActionTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports